import { Link } from "react-router-dom";
import { SphereMark } from "@/components/brand/SphereMark";

export function Logo({ light = false, className }) {
  return (
    <Link
      to="/"
      className={`group inline-flex items-center gap-3 ${className || ""}`}
      data-testid="brand-logo-link"
    >
      <SphereMark size={13} />
      <span
        className={`text-sm font-semibold tracking-[0.14em] uppercase ${
          light ? "text-white" : "text-neutral-900"
        }`}
      >
        Three Words Full
      </span>
    </Link>
  );
}
